import { InsertRowLeftOutlined, UndoOutlined } from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Dropdown,
  Form,
  Input,
  Menu,
  Modal,
  Popconfirm,
  Row,
  Select,
  Space,
  Table,
  Tooltip,
} from "antd";
import "antd/dist/antd.min.css";
import { debounce } from "lodash";
import React, { useEffect, useState } from "react";
import { confirmAlert } from "react-confirm-alert";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { getRequest, patchRequest, postRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { ReactComponent as Archive } from "../../image/Archive.svg";
import { ReactComponent as Archiveicon } from "../../image/Archiveicon.svg";
import { ReactComponent as Editicon } from "../../image/Editicon.svg";
import Padlock from "../../image/padlock.png";
import PlusSquareOutlined from "../../image/PlusSquareOutlined.svg";
import SearchIcon from "../../image/SearchIcon.svg";
import "../../styles/Main.scss";
import { SuccessNotificationMsg } from "../../utils/Notifications";
import { authUserData } from "../../utils/Helper";
import DriverChangePassword from "./DriverChangePassword";
import { ReactComponent as ArchiveButtonicon } from "../../image/ArchiveButtonicon.svg";

const DriverList = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { Search } = Input;
  const [selectedRow, setSelectedRow] = useState([]);
  const [loading, setLoading] = useState(false);
  const [employeeList, setEmployeeList] = useState([]);
  const [modalKey, setModalKey] = useState(false);
  const [changePasswordDriverId, setChangePasswordDriverId] = useState(null);
  const [totalCount, settotalCount] = useState(0);
  const [reload, setReload] = useState(false);
  const { Option } = Select;
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });

  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOkPassword = () => {
    setIsModalOpen(false);
  };
  const handleCancelPassword = () => {
    setIsModalOpen(false);
  };
  useEffect(() => {
    const getEmployeeList = async () => {
      setLoading(true);

      try {
        const params = {
          ...state, // existing state: page, pagesize, search, ordering
          fields:
            "id,status,account_holder_name,tax_file_number,work_on,abn_number,company_name,phone,additional_details,postcode,state,suburb,street_address,email,name", // add the fields param
        };
        let apiResponse = await getRequest("employee/?role=3", params);

        if (apiResponse?.data?.results?.success) {
          setEmployeeList(apiResponse?.data?.results?.data);

          settotalCount(apiResponse.data.count);
          const categories = {};
          apiResponse.data.results.data.forEach((employee) => {
            const categoriesForEmployee = employee.category_tree.map(
              (category) => category.category_tree_name
            );
            categories[employee.id] = categoriesForEmployee;
          });
        } else {
          // ErrorNotificationMsg(t("error_in_employee_list"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getEmployeeList();
  }, [state, reload, t]);

  const handleReset = () => {
    setState({
      ...state,
      search: "",
    });
    form.setFieldsValue({ search: "" });
  };
  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });

    setSelectedRow(selectedRow);
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "name" && sortOrder === "ascend") {
      sortingEnumKey = "name";
    }
    if (sortField === "name" && sortOrder === "descend") {
      sortingEnumKey = "-name";
    }

    if (sortField === "address" && sortOrder === "ascend") {
      sortingEnumKey = "address";
    }
    if (sortField === "address" && sortOrder === "descend") {
      sortingEnumKey = "-address";
    }

    if (sortField === "email" && sortOrder === "ascend") {
      sortingEnumKey = "email";
    }
    if (sortField === "email" && sortOrder === "descend") {
      sortingEnumKey = "-email";
    }

    if (sortField === "phone" && sortOrder === "ascend") {
      sortingEnumKey = "phone";
    }
    if (sortField === "phone" && sortOrder === "descend") {
      sortingEnumKey = "-phone";
    }

    if (sortField === "work_on" && sortOrder === "ascend") {
      sortingEnumKey = "work_on";
    }
    if (sortField === "work_on" && sortOrder === "descend") {
      sortingEnumKey = "-work_on";
    }
    if (sortField === "abn_number" && sortOrder === "ascend") {
      sortingEnumKey = "abn_number";
    }
    if (sortField === "abn_number" && sortOrder === "descend") {
      sortingEnumKey = "-abn_number";
    }
    if (sortField === "tax_file_number" && sortOrder === "ascend") {
      sortingEnumKey = "tax_file_number";
    }
    if (sortField === "tax_file_number" && sortOrder === "descend") {
      sortingEnumKey = "-tax_file_number";
    }
    if (sortField === "account_holder_name" && sortOrder === "ascend") {
      sortingEnumKey = "account_holder_name";
    }
    if (sortField === "account_holder_name" && sortOrder === "descend") {
      sortingEnumKey = "-account_holder_name";
    }
    if (sortField === "status" && sortOrder === "ascend") {
      sortingEnumKey = "status";
    }
    if (sortField === "status" && sortOrder === "descend") {
      sortingEnumKey = "-status";
    }

    return sortingEnumKey;
  };
  const handleStatus = async (user_id, status) => {
    confirmAlert({
      title: t("confirmAlert_title"),
      message: t("pop_driver_status_message"),
      buttons: [
        {
          label: t("confirmAlert_ok"),
          onClick: () => changeStatus(user_id, status),
        },
        {
          label: t("confirmAlert_cancel"),
          onClick: () => navigate("/driver"),
        },
      ],
    });
  };

  const changeStatus = async (id, value) => {
    setLoading(true);

    await patchRequest(`employee-status-change/${id}/`, { status: value })
      .then((response) => {
        SuccessNotificationMsg(t("status_updated_sucessfully"));
        setReload((reload) => !reload);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  const rowSelection = {
    onSelect: (record, selected, selectedRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, record.id]
        : selectedRow.filter((key) => key !== record.id);
      setSelectedRow(updatedSelectedRowKeys);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, ...changeRows.map((row) => row.id)]
        : selectedRow.filter(
            (key) => !changeRows.find((row) => row.id === key)
          );
      setSelectedRow(updatedSelectedRowKeys);
    },
    selectedRowKeys: selectedRow,
  };

  const [checkedList, setCheckedList] = useState([
    "name",
    "email",
    "additional_details",
    "street_address",
    "postcode",
    "state",
    "suburb",
    "phone",
    "work_on",
    "abn_number",
    "tax_file_number",
    "account_holder_name",
    "status",
    "operation",
  ]);
  const [columns, setColumns] = useState([
    {
      title: "Driver Name",
      dataIndex: "name",
      key: "name",
      sorter: true,
      width: 120,
      render: (dataIndex) => (
        // <Tooltip
        //   color={colors}
        //   placement="left"
        //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
        // >
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {dataIndex}
        </div>
        // </Tooltip>
      ),
    },

    {
      title: "E-mail",
      dataIndex: "email",
      key: "email",
      sorter: true,
      width: 200,
      render: (dataIndex) => (
        // <Tooltip
        //   color={colors}
        //   placement="left"
        //   title={
        //     <span style={{ color: "#fff" }}>{dataIndex.toLowerCase()}</span>
        //   }
        // >
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            textTransform: "lowercase",
          }}
        >
          {dataIndex.toLowerCase()}
        </div>
        // </Tooltip>
      ),
    },
    {
      title: "Contact Number",
      dataIndex: "phone",
      key: "phone",
      width: 180,
      render: (phone) => {
        if (phone) {
          const cleanedPhone = String(phone).replace(/\D/g, "");

          if (cleanedPhone.startsWith("91")) {
            return `+91 ${cleanedPhone.slice(2, 7)} ${cleanedPhone.slice(7)}`;
          } else if (cleanedPhone.length > 5) {
            const countryCode = cleanedPhone.slice(0, cleanedPhone.length - 10);
            const localNumber = cleanedPhone.slice(-10);
            return `+${countryCode} ${localNumber.slice(
              0,
              5
            )} ${localNumber.slice(5)}`;
          } else {
            return `+${cleanedPhone}`;
          }
        }
        return null;
      },

      sorter: true,
    },
    {
      title: "Street Address",
      dataIndex: "street_address",
      key: "street_address",
      sorter: true,
      width: 250,
      // render: (text) => (
      //   <Tooltip title={text}>
      //     <span>{text}</span>
      //   </Tooltip>
      // ),
      render: (dataIndex) => (
        // <Tooltip
        //   color={colors}
        //   placement="left"
        //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
        // >
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {dataIndex}
        </div>
        // </Tooltip>
      ),
    },
    {
      title: "State",
      dataIndex: "state",
      key: "state",
      sorter: true,
      width: 120,
    },
    {
      title: "Postcode",
      dataIndex: "postcode",
      key: "postcode",
      sorter: true,
      width: 120,
    },
    {
      title: "Suburb",
      dataIndex: "suburb",
      key: "suburb",
      sorter: true,
      width: 120,
    },
    {
      title: "Additional Details",
      dataIndex: "additional_details",
      key: "additional_details",
      sorter: true,
      width: 200,
      // render: (text) => (
      //   <Tooltip title={text}>
      //     <span>{text}</span>
      //   </Tooltip>
      // ),
      render: (dataIndex) => (
        // <Tooltip
        //   color={colors}
        //   placement="left"
        //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
        // >
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {dataIndex}
        </div>
        // </Tooltip>
      ),
    },

    {
      title: "Work On",
      dataIndex: "work_on",
      key: "work_on",
      sorter: true,
      width: 160,
    },
    {
      title: "ABN Number",
      dataIndex: "abn_number",
      key: "abn_number",
      sorter: true,
      width: 140,
    },
    {
      title: "Tax File Number",
      dataIndex: "tax_file_number",
      key: "tax_file_number",
      sorter: true,
      width: 120,
    },
    {
      title: "Account Holder Name",
      dataIndex: "account_holder_name",
      key: "account_holder_name",
      sorter: true,
      width: 160,
      render: (dataIndex) => (
        // <Tooltip
        //   color={colors}
        //   placement="left"
        //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
        // >
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {dataIndex}
        </div>
        // </Tooltip>
      ),
    },

    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      fixed: "right",
      width: 250,

      render: (e, record) => (
        <div className="SelectStatusSec">
          <Select
            value={e ? e : record.status}
            onChange={(e) => handleStatus(record.id, e)}
            defaultValue={e}
          >
            <Option value="Pending" disabled>
              {" "}
              <div className="discardopt">{t("pending")}</div>
            </Option>
            <Option value="Active">
              {" "}
              <div className="dealdoneopt">{t("active")}</div>
            </Option>
            <Option value="Inactive">
              {" "}
              <div className="contactedopt">{t("inactive")}</div>
            </Option>
          </Select>
        </div>
      ),
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 100,
      render: (text, record) => (
        <Space>
          {/* <Tooltip
            color={colors}
            placement="left"
            title={<span style={{ color: "#fff" }}>Edit</span>}
          > */}
          {authUserData()?.permission.includes("employee|change_employee") && (
            <Link
              to={{
                pathname: "/driver/edit/" + btoa(record.id),
              }}
            >
              <Editicon onClick={() => handleEdit(record.id)} />
            </Link>
          )}
          {/* </Tooltip> */}
          {/* <Tooltip
            color={colors}
            placement="right"
            title={<span style={{ color: "#fff" }}>Archive</span>}
          > */}
          {authUserData()?.permission.includes("employee|delete_employee") && (
            <Popconfirm
              className="action"
              title={t("pop_title")}
              okText={t("pop_ok")}
              cancelText={t("pop_cancel")}
              onConfirm={() => handleArchive(record.id)}
            >
              <Archive style={{ cursor: "pointer" }} />
            </Popconfirm>
          )}
          {/* </Tooltip> */}
          {record?.status === "Active" ? (
            <>
              {/* <Tooltip
                color={colors}
                placement="right"
                title={<span style={{ color: "#fff" }}>Change Password</span>}
              > */}
              {authUserData()?.permission.includes(
                "employee|delete_employee"
              ) && (
                <Popconfirm
                  className="action"
                  title={t("pop_title_password")}
                  okText={t("pop_ok")}
                  cancelText={t("pop_cancel")}
                  onConfirm={() => handleResetPassword(record?.email)}
                >
                  <img
                    src={Padlock}
                    alt="Padlock"
                    style={{ cursor: "pointer" }}
                  />
                </Popconfirm>
              )}
              {/* </Tooltip> */}
            </>
          ) : (
            ""
          )}
        </Space>
      ),
    },
  ]);

  useEffect(() => {
    const updatedColumns = columns.map((column) => ({
      ...column,
      hidden: !checkedList.includes(column.key),
    }));
    setColumns(updatedColumns);
  }, [checkedList, columns]);

  const handleColumnVisibilityChange = (checkedValues) => {
    setCheckedList(checkedValues);
  };

  const columnMenu = (
    <Menu className="packagelistdropdown">
      <Menu.Item>
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
        >
          <Row>
            <Col span={12}>
              <Checkbox value="name">Driver Name</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="email">E-mail</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="additional_details">Additional Details</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="suburb">Suburb</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="postcode">Postcode</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="state">State</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="street_address">Street Address</Checkbox>
            </Col>

            <Col span={12}>
              <Checkbox value="phone">Contact Number</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="work_on">Work On</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="abn_number">ABN Number</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="tax_file_number">Tax File Number</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="account_holder_name">
                Account Holder Name
              </Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="status" disabled>
                Status
              </Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="operation" disabled>
                Action
              </Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  const handleArchive = async (id = []) => {
    // let ids = selectedRow;
    // if (ids.length === 0) {
    //   ids.push(id);
    // }
    let ids = [...selectedRow];

    if (ids.length === 0 && id) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest("employee/archive-employee/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        let totalArchive = totalCount - ids.length;
        if (totalArchive < 11) {
          setState((prevState) => ({
            ...prevState,
            page: 1,
            search: "",
          }));
          setReload(!reload);
        } else {
          setReload(!reload);
        }
        SuccessNotificationMsg(t("Driver Archive Successfully"));

        setSelectedRow([]);
      } else {
        setState((prevState) => ({
          ...prevState,
          page: 1,
          search: "",
        }));
      }
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        page: 1,
        search: "",
      }));
    }
  };
  const handleResetPassword = async (id = []) => {
    setModalKey((prevKey) => !prevKey);
    setChangePasswordDriverId(id);
    showModal();
  };
  const handleEdit = (id) => {};

  const [isModalOpenBulk, setIsModalOpenBulk] = useState(false);
  const handleOkBulk = () => {
    setIsModalOpenBulk(false);
  };
  const handleCancelBulk = () => {
    setIsModalOpenBulk(false);
  };
  const colors = ["#737373"];

  return (
    <>
    <div className="mainwrapper">
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            {/* <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  View & Manage The List Of Employees Within The Organization.
                </span>
              }
            > */}
            <h3>{t("Driver List")}</h3>
            {/* </Tooltip> */}

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("Driver")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp" style={{ height: "40px" }}>
              <Space direction="vertical">
                <Form form={form}>
                  <Form.Item name="search" initialValue="">
                    <Search
                      prefix={
                        <img
                          src={SearchIcon}
                          alt="SearchIcon"
                          className="SearchIcon"
                          width={22}
                        />
                      }
                      placeholder={t("pl_search_list")}
                      onChange={searchCallbackDelayed}
                      style={{
                        width: 250,
                      }}
                    />
                  </Form.Item>
                </Form>
              </Space>
            </div>
            {state?.search ? (
              // <Tooltip title="Reset search">
              <Button
                className="BlueShadowBtn"
                type="primary"
                htmlType="button"
                onClick={() => handleReset()}
              >
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <UndoOutlined style={{ fontSize: "18px", color: "#fff" }} />{" "}
                  Reset
                </span>
              </Button>
            ) : (
              // </Tooltip>
              ""
            )}
            {/* <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  Add A New Driver To The Organization&apos;s Database.
                </span>
              }
            > */}
            {authUserData()?.permission.includes("employee|add_employee") && (
              <Button
                className="BlueShadowBtn"
                type="primary"
                onClick={() => navigate("/driver/add")}
                icon={<img src={PlusSquareOutlined} alt="Plus Square" />}
              >
                {t("Add Driver")}
              </Button>
            )}
            {/* </Tooltip> */}

            <Modal
              className="ModelPopupSec"
              title={t("Change Password")}
              open={isModalOpen}
              onOk={handleOkPassword}
              onCancel={handleCancelPassword}
              closable={false}
              wrapClassName="modal-wrapper"
              keyboard={false}
            >
              <DriverChangePassword
                handleCancel={handleCancelPassword}
                setReload={setReload}
                changePasswordDriverId={changePasswordDriverId}
                modalKey={modalKey}
                setStateM={setState}
              />
            </Modal>
            <Modal
              className="ModelPopupSec"
              title="Upload File"
              open={isModalOpenBulk}
              onOk={handleOkBulk}
              onCancel={handleCancelBulk}
              closable={false}
              wrapClassName="modal-wrapper"
            ></Modal>
            {authUserData()?.permission.includes(
              "employee|delete_employee"
            ) && (
              <>
                {selectedRow.length > 0 && (
                  <Popconfirm
                    className="action"
                    title={t("pop_title")}
                    okText={t("pop_ok")}
                    cancelText={t("pop_cancel")}
                    placement="left"
                    onConfirm={() => handleArchive()}
                  >
                    <ButtonField
                      className="BlueShadowBtn"
                      type="primary"
                      htmlType="button"
                      label={
                        <>
                          <div
                            className="BlueShadowBtn"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            <ArchiveButtonicon />
                            <span>{t("pl_archive")}</span>
                          </div>
                        </>
                      }
                    />
                  </Popconfirm>
                )}
              </>
            )}
            {authUserData()?.permission.includes(
              "employee|delete_employee"
            ) && (
              // <Tooltip placement="topLeft" title="View Archived Records">
              <Link className="Archiveicon" to="/driver/archive">
                <Archiveicon />
              </Link>
              // </Tooltip>
            )}
            <div className="gridiconswrap">
              {/* <Tooltip placement="topLeft" title="Column Filter Options"> */}
              <Dropdown
                overlay={columnMenu}
                trigger={["click"]}
                placement="bottomRight"
                visible={dropdownVisible}
                onVisibleChange={(visible) => setDropdownVisible(visible)}
              >
                <Button
                  type="primary"
                  shape="circle"
                  icon={<InsertRowLeftOutlined />}
                  onClick={() => setDropdownVisible(!dropdownVisible)}
                />
              </Dropdown>
              {/* </Tooltip> */}
            </div>
          </Space>
        </div>
      </div>

      <section className="grid-sec">
        <div className="Package-body">
          <div className="tablewrp">
          <Table
            rowSelection={rowSelection}
            columns={columns.filter((col) => !col.hidden)}
            rowKey={(record) => record.id}
            dataSource={employeeList}
            loading={loading}
            pagination={{
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              total: totalCount,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: true,
              locale: {
                items_per_page: "Items / Page",
              },
            }}
            onChange={handleTableChange}
            scroll={{
              x: 1000,
            }}
          />
        </div></div>
      </section>
      </div>
    </>
  );
};
export default DriverList;
